import { render, staticRenderFns } from "./NakaBinding.vue?vue&type=template&id=8687c542&scoped=true&"
import script from "./NakaBinding.vue?vue&type=script&lang=ts&"
export * from "./NakaBinding.vue?vue&type=script&lang=ts&"
import style0 from "./NakaBinding.vue?vue&type=style&index=0&id=8687c542&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8687c542",
  null
  
)

export default component.exports